import { IQuoteBasicRespSchema } from '@monetize/types/app';
import { Popover, Portal } from '@chakra-ui/react';
import { MButton, MVStack } from '../../Monetize';
import { RenewalQuoteChip } from './RenewalQuoteChip';

/** One or two renewals is the norm; more collapse behind "+N more" */
export const MAX_VISIBLE_RENEWAL_QUOTES = 2;

const HIDDEN_QUOTES_POSITIONING = { placement: 'bottom-start' } as const;

/**
 * The renewal quotes in progress for one lineage, stacked after its last term.
 * Extra quotes open in a popover so a busy lineage keeps a sane card height.
 */
export const RenewalQuoteStack = ({
  quotes,
  testIdSuffix,
}: {
  quotes: IQuoteBasicRespSchema[];
  /** Keeps the "+N more" testid unique when several cards are on screen */
  testIdSuffix: string;
}) => {
  const visibleQuotes = quotes.slice(0, MAX_VISIBLE_RENEWAL_QUOTES);
  const hiddenQuotes = quotes.slice(MAX_VISIBLE_RENEWAL_QUOTES);

  return (
    <MVStack gap={2} align="stretch">
      {visibleQuotes.map((quote) => (
        <RenewalQuoteChip key={quote.id} quote={quote} />
      ))}
      {hiddenQuotes.length > 0 && (
        <Popover.Root
          lazyMount
          unmountOnExit
          positioning={HIDDEN_QUOTES_POSITIONING}
        >
          <Popover.Trigger asChild>
            <MButton
              variant="link"
              size="xs"
              alignSelf="flex-start"
              data-testid={`renewal-quotes-more-btn-${testIdSuffix}`}
            >
              +{hiddenQuotes.length} more
            </MButton>
          </Popover.Trigger>
          {/* The chain scrolls sideways, which would clip an inline popover */}
          <Portal>
            <Popover.Positioner>
              <Popover.Content w="auto">
                <Popover.Body>
                  <MVStack gap={2} align="stretch">
                    {hiddenQuotes.map((quote) => (
                      <RenewalQuoteChip key={quote.id} quote={quote} />
                    ))}
                  </MVStack>
                </Popover.Body>
              </Popover.Content>
            </Popover.Positioner>
          </Portal>
        </Popover.Root>
      )}
    </MVStack>
  );
};
